import React, { Component } from 'react'
import moment from 'moment'

class RecentPost extends Component {
  constructor(props) {
    super(props)
    this.state = {

    }
  }

  render() {
    const { detail } = this.props
    return (
      <li className="single-news clearfix">
        <img src={detail.image} alt={detail.slug} />
        <div className="post float-left">
          <h6><a href={`/blog/${detail.slug}`} className="tran3s">{detail.title}</a></h6>
          <p><i className="fa fa-clock-o" aria-hidden="true"></i> {moment(detail.created).format('Do MMMM, YYYY')}</p>
        </div>
      </li>
    )
  }
}

export default RecentPost